/**<params config data>说明
 * titleFontSize 标题文字大小 number
 * titleColor 标题文字颜色 string
 * desFontSize 描述文字大小 number
 * desColor 描述文字颜色 string
 * background 颜色：string
 * textAlign  文本框对齐 string  left center right
 * itemsColor  底部大文字颜色 string
 * itemsbomColor  底部小文字颜色 string
 * position 定位 string
 * data 数据 array
 */
import ScrollAnimation from '@/components/Animate';
import css from './index.module.scss';
const items = [
    {
        title: 'Power pretty much anything',
        des: 'Keep your home comforts running during a blackout. AC units, kitchen appliances and power tools are all accessible with DELTA Pro. Use a single unit to power up to 4500W¹ of appliances. Need even more power? Chain two units together to hit a record-breaking 7200W, 240V output².',
        remarks: '² Requires use of the Double Voltage Hub or Smart Home Panel (both sold separately).',
        arr: [
            { num: '3.6', eum: 'kWh', des: 'Expandable Capacity' },
            { num: '3.5', eum: 'kWh', des: 'Expandable Capacity' },
        ],
    },
];
const configs = {
    position: 'top',
    animateIn: 'fadeInUp',
    titleFontSize: 56,
    titleColor: '#03060b',
    desFontSize: 22,
    desColor: '#919191',
    textAlign: 'center',
    itemsColor: '#03060b',
    itemsbomColor: '#919191',
};
export default function TextModule({ config, data = items }: any) {
    const configTypes = { ...configs, ...config };
    const arr: any = {
        xs: 30,
        sm: 60,
        md: 90,
        lg: 120,
        xl: 150,
        xxl: 180,
    };
    let maxWidth = '924px';
    if (configTypes.textAlign != 'center') {
        maxWidth = '532px';
    }
    return (
        <div
            className={`${css.TextModule} TextModulebox`}
            style={{
                textAlign: configTypes.textAlign,
                position: configTypes.position == 'top' ? 'initial' : 'relative',
                minHeight: configTypes.position == 'top' ? 'auto' : '540px',
            }}
        >
            {data.map((item: any, i: any) => (
                <div
                    key={item.title}
                    className={
                        configTypes.position == 'top'
                            ? 'content centerposition'
                            : configTypes.position == 'left'
                            ? 'content leftPosition'
                            : 'content rightPosition'
                    }
                    style={{ maxWidth: maxWidth }}
                >
                    <ScrollAnimation animateIn={configTypes.animateIn}>
                        <h2
                            className="title font-family-medium"
                            style={{
                                fontSize: configTypes.titleFontSize + 'px',
                                color: configTypes.titleColor,
                            }}
                        >
                            {item.title}
                        </h2>
                        <p
                            className="des font-family-medium"
                            style={{
                                fontSize: configTypes.desFontSize + 'px',
                                color: configTypes.desColor,
                            }}
                        >
                            {item.des}
                        </p>
                        {configTypes.textAlign == 'center' && (
                            <div className="remarks font-family-medium" style={{ color: configTypes.desColor }}>
                                {item.remarks}
                            </div>
                        )}
                        {configTypes.textAlign != 'center' && (
                            //  <ScrollAnimation animateIn='fadeInUp'>
                            <div className="items">
                                <ul>
                                    {item.arr &&
                                        item.arr.map((list: any, j: any) => (
                                            <li key={list.num}>
                                                <span className="num font-family-extrabold" style={{ color: configTypes.itemsColor }}>
                                                    {list.num}
                                                    <b className="unit font-family-light">{list.eum}</b>
                                                </span>
                                                <p className="title font-family-light" style={{ color: configTypes.itemsbomColor }}>
                                                    {list.des}{' '}
                                                </p>
                                            </li>
                                        ))}
                                </ul>
                            </div>
                        )}
                    </ScrollAnimation>
                </div>
            ))}
        </div>
    );
}
